module.exports = __webpack_public_path__ + "static/media/030.b731ebe1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/030.jpg
// module id = 327
// module chunks = 0